import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, throwError, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { retry } from 'rxjs/operators';
import {
  Apps,
  ContainerStatus,
  ContainerType,
  InventoryTypes
} from '../enum/enum';
import { environment } from '../environments/environment';
import {
  Conditions,
  CreateStationSessionResponse,
  deptpriceconfig,
  goals,
  grades,
  HeartbeatLicenseResponse,
  Inventory,
  Labels,
  LicenseplateItems,
  LicensePlateItemSerial,
  LicensePlates,
  LoginModel,
  Permissions,
  production,
  ProductionMetadata,
  ProductionOverride,
  ProductionOverrideLicensePlates,
  Sizes,
  Stations,
  UserFavoriteRequestModel,
  UserModel,
  UserRolesModel
} from '../Models/ApplicationModels';
import {
  containerRequestModel,
  containerResponse
} from '../rcs/admin-module/inventory-management/Container/Model/Container';
import { LicensePlateStatus } from './enum';
import { param } from 'jquery';
@Injectable({
  providedIn: 'root'
})
export class MasterDataSeriveService {
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string
  ) { }

  baseCompanyMangUrl: string = environment.companyApiBaseUrl;
  baseImsUrl: string = environment.imsApiUrl;
  womenmethod: string = 'departmentscategory';
  getcolors: string = 'weekcolor';
  getColorsScheduleURL: string = 'weekcolorschedule';
  getsizeprice: string = 'getsizepricing';
  getcompanylists: string = 'getcompanylist';
  addBrandsDetailsUrl: string = 'brands';
  addUpdateStore: string = 'addupdatestore';
  StoreGroupUrl: string = 'getallstoregroup';
  selectedStoreGrpIndex: number = 0;
  dataForPriceConfig: Array<any> = [];
  performerDashboardURL: string = 'production';
  storePerformerDashboardURL: string = 'store';
  userPermissions: Array<Permissions> = [];
  getColorsScheduleByDateUrl: string = 'getColorsScheduleByDate';

  getProductionSubCategory(
    companyId: number,
    departmentId: number,
    categoryId: number
  ) {
    const url = `${this.baseUrl + 'Departments/'
      }productionSubCategories?companyId=${companyId}&departmentId=${departmentId}&categoryId=${categoryId}`;
    return this.http.get(url).pipe(this.retryOnServerError());
  }

  getMainDepartments() {
    let userdata = this.getUserDetailsFromStorage();
    let companyId = userdata.companyID;
    const url = `${this.baseUrl}departments?companyId=${companyId}`;
    return this.http.get(url);
  }

  getDepartmentsProduction(IsProduction: boolean, storeGroupId: number) {
    let userdata = this.getUserDetailsFromStorage();
    let userId = userdata.userId;
    let companyId = userdata.companyID;
    const url = `${this.baseUrl}departments/production?CompanyId=${companyId}&UserId=${userId}&IsProduction=${IsProduction}&StoreGroupId=${storeGroupId}`;
    return this.http.get<any[]>(url).pipe(
      this.retryOnServerError<any[]>(),
      map((departments: any[]) =>
        departments.sort((a, b) => {
          const orderA = a.sortOrder ?? 0;
          const orderB = b.sortOrder ?? 0;
          if (!orderA && orderB) return 1;
          if (orderA && !orderB) return -1;
          return orderA - orderB;
        })
      )
    );
  }

  // getweekcolors() {
  //   let userdata = this.getUserDetailsFromStorage();
  //   let c_id = userdata.companyID;
  //   const url = `${this.baseUrl + 'colors/'}${
  //     this.getcolors
  //   }?CompanyID=${c_id}`;
  //   return this.http.get(url);
  // }

  // getWeekColorById(productionCycleId: number) {
  //   const url = `${this.baseUrl + 'colors/'}${productionCycleId}`;
  //   return this.http.get(url);
  // }

  // getWeekColorsSchedule() {
  //   let userdata = this.getUserDetailsFromStorage();
  //   let c_id = userdata.companyID;
  //   const url = `${this.baseUrl + 'colors/'}${
  //     this.getColorsScheduleURL
  //   }?CompanyID=${c_id}`;
  //   return this.http.get(url);
  // }

  // addUpdateColor(data: ColorsModel) {
  //   const url = `${this.baseUrl + 'colors/'}`;
  //   return this.http.post(url, data);
  // }

  // removeColor(clrIds: string) {
  //   const url = `${this.baseUrl}colors/${clrIds}`;
  //   return this.http.delete(url);
  // }

  // addUpdateColorSchedule(data: ColorScheduleModel) {
  //   const url = `${this.baseUrl + 'colors/'}schedule`;
  //   return this.http.post(url, data);
  // }

  getSizePricing(
    companyID: number,
    departmentId: number,
    categoryId: number,
    subCategoryID: number,
    storeId: number
  ) {
    const url = `${this.baseUrl}sizepricing/prices`;
    const params = {
      companyId: companyID.toString(),
      departmentTypeId: '0',
      departmentId: departmentId.toString(),
      categoryId: categoryId.toString(),
      subCategoryId: subCategoryID.toString(),
      storeId: storeId.toString()
    };
    return this.http.get(url, { params });
  }

  getGoalValues() {
    const url = `${this.baseUrl + 'goals/'}values`;
    return this.http.get(url);
  }

  getGoalIntervals() {
    const url = `${this.baseUrl + 'goals/'}intervals`;
    return this.http.get(url);
  }

  getGoalGroups(companyID: number) {
    const url = `${this.baseUrl + 'goals/'}groups?companyID=${companyID}`;
    return this.http.get(url);
  }

  getGoals(companyId: number) {
    const url = `${this.baseUrl}goals?c_id=${companyId}`;
    return this.http.get(url);
  }

  getGoalTypes() {
    const url = `${this.baseUrl + 'goals/'}types`;
    return this.http.get(url);
  }

  addUpdateGoal(data: goals) {
    const url = `${this.baseUrl + 'goals'}`;
    return this.http.post(url, data);
  }

  getDepartmentById(id: number) {
    const url = `${this.baseUrl}departments/${id}`;
    return this.http.get(url);
  }

  getGrades(companyId: number) {
    const url = `${this.baseUrl + 'grades'}?companyId=${companyId}`;
    return this.http.get(url);
  }

  addupdategrade(data: grades) {
    const url = `${this.baseUrl + 'grades'}`;
    return this.http.post(url, data);
  }
  //stores
  getallstores(id: number) {
    const url = `${this.baseUrl + 'Stores/'}?companyID=${id}`;
    return this.http.get(url);
  }

  getStationslist(id: number) {
    const url = `${this.baseUrl + 'stations/'}?CompanyId=${id}`;
    return this.http.get<Stations[]>(url);
  }

  addStation(data: Stations) {
    const url = `${this.baseUrl + 'stations'}`;
    return this.http.post(url, data);
  }

  getCategoriesByDeptUserID(
    deptID: number,
    userID: number,
    IsProduction: Boolean,
    storeGroupId: number
  ) {
    const url = `${this.baseUrl}departments/types?DepartmentId=${deptID}&UserId=${userID}&IsProduction=${IsProduction}&storeGroupId=${storeGroupId}`;
    return this.http.get(url).pipe(this.retryOnServerError());
  }

  private retryOnServerError<T>(maxRetries = 2, baseDelayMs = 500) {
    return (source: Observable<T>) =>
      source.pipe(
        retry({
          count: maxRetries,
          delay: (error: any, retryCount: number) => {
            if (error?.status >= 500) {
              return timer(baseDelayMs * retryCount);
            }

            return throwError(() => error);
          }
        })
      );
  }
  // Service for getting admin's categories with sizing data.
  getCategoryAdmin(companyID: number) {
    const url = `${this.baseUrl + 'departments/categories/admin'
      }?companyID=${companyID}`;
    return this.http.get(url);
  }
  // Services for sizing Crud
  getAllSizes(c_id: number) {
    const url = `${this.baseUrl + 'sizepricing/'}sizes?companyID=${c_id}`;
    return this.http.get(url);
  }

  addUpdateSize(sizeData: Sizes[]) {
    const url = `${this.baseUrl + 'sizepricing/'}sizes`;
    return this.http.post(url, sizeData);
  }

  deleteSizes(sizeIds: string) {
    const url = `${this.baseUrl + 'sizepricing/sizes'}?sizeIds=${sizeIds}`;
    return this.http.delete(url);
  }
  //USERS
  getProcessorUsers(companyId: number) {
    const url = `${this.baseUrl + 'ProcessorUsers?'}companyId=${companyId}`;
    return this.http.get(url);
  }

  deleteStation(stationIds: string) {
    const url = `${this.baseUrl}stations/${stationIds}`;
    return this.http.delete(url);
  }

  deleteGrade(gradeIds: string) {
    const url = `${this.baseUrl}grades/${gradeIds}`;
    return this.http.delete(url);
  }

  deleteGoal(goalIds: string) {
    const url = `${this.baseUrl + 'goals'}/${goalIds}`;
    return this.http.delete(url);
  }

  deletePricingConfig(priceIds: string) {
    const url = `${this.baseUrl + 'sizepricing/'}prices?priceIds=${priceIds}`;
    return this.http.delete(url);
  }
  //priceconfig
  getDeptPricingConfig() {
    const url = `${this.baseUrl + 'pricingconfig/'}pricing-type`;
    return this.http.get(url);
  }

  getPricingTypeConfig(companyID: number) {
    const url = `${this.baseUrl + 'pricingconfig/'}${companyID}`;
    return this.http.get(url);
  }

  getHierarchicalData(companyId: number, storeId: number) {
    const url = `${this.baseUrl + 'chatbot/'}hierarchical-data?companyId=${companyId}&storeId=${storeId}`;
    return this.http.get(url);
  }

  removeTimeFromDate(dateString: string) {
    if (dateString != null) {
      const parts = dateString.split(' ');
      const datePart = parts[0];
      return datePart;
    }
    return '';
  }

  getUserDetailsFromStorage() {
    let userdata: LoginModel = new LoginModel();
    let user: any = localStorage.getItem('user');
    let userdetails = JSON.parse(user);
    userdata = userdetails;
    return userdata;
  }
  //userFavorite
  addUpdateUserFavorite(data: UserFavoriteRequestModel) {
    const url = `${this.baseUrl}departments/favorites`;
    return this.http.post(url, data);
  }

  getUserFavourites(userId: number) {
    const storeId = JSON.parse(
      localStorage.getItem('tempStoreId') || localStorage.getItem('storeId')!
    );
    const url = `${this.baseUrl}departments/favorites?userId=${userId}&storeId=${storeId}`;
    return this.http.get(url);
  }
  //conditions
  getAllConditions(companyID: number) {
    const url = `${this.baseUrl}Conditions/?CompanyId=${companyID}`;
    return this.http.get(url);
  }

  addUpdateConditions(condition: Conditions) {
    const url = `${this.baseUrl + 'Conditions/'}`;
    return this.http.post(url, condition);
  }

  removeConditions(conditionIds: string) {
    const url = `${this.baseUrl + 'Conditions/'}${conditionIds}`;
    return this.http.delete(url);
  }
  //Labels
  getAllLabels(companyID: number) {
    const url = `${this.baseUrl}SharedLabelFormats`;
    return this.http.get(url, {
      params: {
        companyId: companyID
      }
    });
  }

  addUpdateLabel(label: Labels) {
    const url = `${this.baseUrl + 'labels'}`;
    return this.http.post(url, label);
  }

  removeLabel(labelIds: string) {
    const url = `${this.baseUrl + 'labels/'}${labelIds}`;
    return this.http.delete(url);
  }

  getAllInventoryLabels(companyId: number) {
    const url = `${this.baseUrl}Labels/inventoryLabels?companyId=${companyId}`;
    return this.http.get(url);
  }

  getPriceConfigTemplate(
    Company_Id: number,
    Pricingtype_Id: number,
    DepartmentID: number,
    storeGroupId: number
  ) {
    const url = `${this.baseUrl + 'pricingconfig/'
      }company/${Company_Id}/type/${Pricingtype_Id}/department/${DepartmentID}/group/${storeGroupId}`;
    return this.http.get(url);
  }
  //ProducitonWorking
  addProductionWorking(data: production) {
    const url = `${this.baseUrl + 'productionworking'}`;
    return this.http.post(url, data);
  }

  addupdatelistofprices(data: any, isImport: boolean = false) {
    const url = `${this.baseUrl + 'sizepricing/'}prices?IsImport=${isImport}`;
    return this.http.post(url, data);
  }

  updatePriceConfig(price: deptpriceconfig) {
    const url = `${this.baseUrl + 'pricingconfig/'}pricing-config`;
    return this.http.put(url, price);
  }

  getPriceForCategory(
    companyID: number,
    priceTypeID: number,
    storeGroupId: number,
    departmentId: number,
    categoryId: number,
    subcategoryID: number
  ) {
    const url = `${this.baseUrl + 'sizepricing/'
      }prices/category?companyID=${companyID}&storeTypeID=${storeGroupId}&pricingTypeID=${priceTypeID}&departmentId=${departmentId}&categoryId=${categoryId}&subCategoryID=${subcategoryID}`;
    return this.http.get(url);
  }

  getpricefordepartment(
    companyID: number,
    priceTypeID: number,
    storeGroupId: number,
    departmentId: number
  ) {
    const url = `${this.baseUrl + 'sizepricing/'
      }prices/department?companyID=${companyID}&storeTypeID=${storeGroupId}&pricingTypeID=${priceTypeID}&departmentId=${departmentId}`;
    return this.http.get(url);
  }
  //Production History
  // userId is optional: omit it to search the caller's whole company (used by barcode
  // search so a tag can be found and reprinted by someone other than its producer).
  getHistoryByDateRange(
    userId: number | undefined,
    startDate: string | null,
    endDate: string | null,
    barcode?: string,
    includeDeleted?: boolean,
    pageNumber?: number,
    pageSize?: number
  ) {
    let params = new HttpParams()
      .set('startDate', startDate || 'null')
      .set('endDate', endDate || 'null');
    if (barcode && barcode.trim() !== '') {
      params = params.set('barcode', barcode);
    }
    if (userId) {
      params = params.set('userId', userId);
    }
    params = params.set('includeDeleted', String(includeDeleted));
    if (pageNumber) {
      params = params.set('pageNumber', pageNumber.toString());
    }
    if (pageSize) {
      params = params.set('pageSize', pageSize.toString());
    }
    const url = `${this.baseUrl}ProductionHistory`;
    return this.http.get(url, { params });
  }

  delHistory(barcodes: string[]) {
    const url = `${this.baseUrl + 'productionWorking/'}bulk`;
    const payload = { Deletes: barcodes };
    return this.http.post(url, payload);
  }

  getBrandProduction(deptID: number) {
    const url = `${this.baseUrl}Departments/${deptID}/productionBrands`;
    return this.http.get(url);
  }

  printLastLabel(barcodes: string) {
    const url = `${this.baseUrl + 'productionworking/'
      }last-label?barcodes=${barcodes}`;
    return this.http.get(url);
  }

  getProductionQuantity(companyID: number) {
    const url = `${this.baseUrl + 'productionworking/'
      }production-quantity/${companyID}`;
    return this.http.get(url);
  }

  printHistoryLabel(barcode: string, includeDeleted?: boolean) {
    const url = `${this.baseUrl + 'productionhistory/'
      }${barcode}/print-label?includeDeleted=${includeDeleted}`;
    return this.http.get(url);
  }

  getInventory(companyId: number, type: InventoryTypes) {
    const url = `${this.baseUrl + 'inventory/'}${companyId}?type=${type}`;
    return this.http.get(url);
  }

  getInventoryByUser(userId: number, companyId: number) {
    const url = `${this.baseUrl + 'inventory/'
      }${companyId}/users/${userId}/inventory`;
    return this.http.get(url);
  }

  addJournal(data: Inventory[]) {
    const url = `${this.baseUrl + 'inventory/'}journal-entry`;
    return this.http.post(url, data);
  }

  filterJournal(filterJournal: any) {
    const url = `${this.baseUrl}inventory/filters`;
    const payload = {
      includeDepartment: filterJournal.includeDepartment,
      departmentIds: filterJournal.departmentIds || '',
      includeCategory: filterJournal.includeCategory,
      categoryIds: filterJournal.categoryIds || '',
      includeStore: filterJournal.includeStore,
      storeIds: filterJournal.storeIds || '',
      includeColor: filterJournal.includeColor,
      colorIds: filterJournal.colorIds || '',
      includeLocation: filterJournal.includeLocation,
      locationIds: filterJournal.locationIds || '',
      includeBarcode: filterJournal.includeBarcode ?? false,
      barcodeValues: filterJournal.barcodeValues || '',
      companyID: filterJournal.companyID,
      pageNumber: filterJournal.pageNumber ?? 1,
      pageSize: filterJournal.pageSize ?? 20,
      isExport: filterJournal.isExport ?? false
    };
    return this.http.post(url, payload);
  }

  filterFloorJournal(
    dept: boolean,
    catg: boolean,
    userID: number,
    clr: boolean,
    loc: boolean,
    companyID: number
  ) {
    const url = `${this.baseUrl}inventory/${companyID}/users/${userID}/floor-filters?dept=${dept}&catg=${catg}&clr=${clr}&loc=${loc}`;
    return this.http.get(url);
  }

  getAIPrice(deptID: number, catgID: number, brandID: number) {
    const url = `${this.baseUrl + 'sizepricing/'
      }ai/prices?DepartmentId=${deptID}&CategoryId=${catgID}&brandId=${brandID}`;
    return this.http.get(url);
  }

  // getProductioncycle() {
  //   let user = this.getUserDetailsFromStorage();
  //   const url = `${this.baseUrl + 'productionworking/'}production-cycle/${
  //     user.userId
  //   }`;
  //   return this.http.get(url);
  // }

  deletePricingDept(
    deptID: number,
    pricingID: number,
    storeGrpID: number,
    companyID: number
  ) {
    const url = `${this.baseUrl + 'pricingconfig/'
      }department/${deptID}/pricing/${pricingID}/company/${companyID}/group/${storeGrpID}`;
    return this.http.delete(url);
  }

  checkunaddedPrices(companyID: number) {
    const url = `${this.baseUrl + 'pricingconfig/'}unadded-prices/${companyID}`;
    return this.http.get(url);
  }
  //Dashboard
  getDashboardDepartment(
    companyID: number,
    dashboardID: number,
    startDate: string,
    endDate: string
  ) {
    let user = this.getUserDetailsFromStorage();
    const url = `${this.baseUrl + 'Dashboard/departments/'
      }${dashboardID}?companyID=${companyID}&startDate=${startDate}&endDate=${endDate}&userID=${user.userId
      }`;
    return this.http.get(url);
  }

  getDashboardTable(
    companyID: number,
    departmentId: number,
    startDate: string,
    endDate: string
  ) {
    let user = this.getUserDetailsFromStorage();
    const url = `${this.baseUrl + 'Dashboard/departments/'
      }${departmentId}/table?companyID=${companyID}&startDate=${startDate}&endDate=${endDate}&userID=${user.userId
      }`;
    return this.http.get(url);
  }

  getAdminDashboardDetails(
    companyID: number,
    storeId: number | null,
    departmentId: string | null,
    startDate: any,
    endDate: any,
    productionCycleId: number | null,
    isActive: boolean | null,
    categoryId: number = 0,
    subCategoryId: number = 0
  ) {
    if (departmentId === '') {
      departmentId = '0';
    }
    let user = this.getUserDetailsFromStorage();
    const url = `${this.baseUrl + 'Dashboard/admin/'
      }${storeId}/dashboard?companyID=${companyID}&departmentId=${departmentId}&startDate=${startDate}&endDate=${endDate}&userID=${user.userId
      }&productionCycleId=${productionCycleId}&isActive=${isActive}&categoryID=${categoryId}&subCategoryID=${subCategoryId}`;
    return this.http.get(url);
  }

  getAdminDashboardTableDetails(
    companyID: number,
    storeId: number | null,
    departmentId: string | null,
    startDate: any,
    endDate: any,
    productionCycleId: number | null,
    isActive: boolean | null,
    categoryId: number = 0,
    subCategoryId: number = 0
  ) {
    if (departmentId === '') {
      departmentId = '0';
    }
    let user = this.getUserDetailsFromStorage();
    const url = `${this.baseUrl + 'Dashboard/admin/'
      }${storeId}/dashboard/table?companyID=${companyID}&departmentId=${departmentId}&startDate=${startDate}&endDate=${endDate}&userID=${user.userId
      }&productionCycleId=${productionCycleId}&isActive=${isActive}&categoryID=${categoryId}&subCategoryID=${subCategoryId}`;
    return this.http.get(url);
  }
  /*getEmployee report*/
  getEmpReportTableData(
    companyID: number,
    storeId: number,
    departmentId: string,
    categoryId: number,
    startDate: string | any,
    endDate: string | any,
    productionCycleId: number | null,
    employeeIds: number[] = [],
    subCategoryId: number = 0
  ) {
    let user = this.getUserDetailsFromStorage();
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const employeeIdsParam =
      Array.isArray(employeeIds) && employeeIds.length
        ? employeeIds.join(',')
        : (employeeIds || 0);
    const url =
      `${this.baseUrl}Reports/EmployeeReport?` +
      `CompanyId=${companyID}` +
      `&DepartmentId=${departmentId}` +
      `&CategoryId=${categoryId}` +
      `&SubCategoryId=${subCategoryId}` +
      `&StoreId=${storeId}` +
      `&UserId=${user.userId}` +
      `&StartDate=${startDate ?? ''}` +
      `&EndDate=${endDate ?? ''}` +
      `&ProductionCycleId=${productionCycleId ?? 0}` +
      `&EmployeeIds=${employeeIdsParam}` +
      `&Timezone=${encodeURIComponent(userTimezone || '')}`;
    return this.http.get(url);
  }

  getEmpDashboard(
    companyID: number,
    storeId: number,
    departmentId: string,
    goalValueID: number,
    goalIntervalID: number,
    categoryId: number,
    startDate: string | any,
    endDate: string | any,
    productionCycleId: number | null,
    employeeIds: number[] | number = [],
    subCategoryId: number = 0
  ) {
    let user = this.getUserDetailsFromStorage();
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let params = new HttpParams()
      .set('CompanyID', companyID)
      .set('UserID', user.userId)
      .set('StoreID', storeId)
      .set('DepartmentID', departmentId)
      .set('GoalValueID', goalValueID)
      .set('GoalIntervalID', goalIntervalID)
      .set('CategoryID', categoryId)
      .set('SubCategoryID', subCategoryId)
      .set('StartDate', startDate ? startDate : '')
      .set('EndDate', endDate ? endDate : '')
      .set('ProductionCycleId', productionCycleId ?? 0)
      .set('Timezone', userTimezone || '');

    if (Array.isArray(employeeIds)) {
      params = params.set(
        'EmployeeIds',
        employeeIds.length ? employeeIds.join(',') : 0
      );
    } else if (employeeIds) {
      params = params.set('EmployeeIds', employeeIds);
    } else {
      params = params.set('EmployeeIds', 0);
    }

    const url = `${this.baseUrl}Reports/EmployeeReportDashboard`;
    return this.http.get(url, { params });
  }

  private formatLocalDateTimeForApi(
    dateValue: string | Date | null | undefined
  ): string {
    if (!dateValue || dateValue === 'null') {
      return 'null';
    }

    const parsedDate =
      dateValue instanceof Date ? dateValue : new Date(dateValue);
    if (isNaN(parsedDate.getTime())) {
      return 'null';
    }

    const pad = (value: number) => value.toString().padStart(2, '0');
    return `${parsedDate.getFullYear()}-${pad(parsedDate.getMonth() + 1)}-${pad(parsedDate.getDate())} ${pad(parsedDate.getHours())}:${pad(parsedDate.getMinutes())}:${pad(parsedDate.getSeconds())}`;
  }

  /*sell through report */
  getSellThroughData(
    companyID: number,
    storeId: string,
    departmentId: string,
    categoryId: number,
    startDate: string | any,
    endDate: string | any,
    productionCycleId: number | null,
    subCategoryId: number = 0
  ) {
    const startDateFormatted = this.formatLocalDateTimeForApi(startDate);
    const endDateFormatted = this.formatLocalDateTimeForApi(endDate);
    let user = this.getUserDetailsFromStorage();
    const url = `${this.baseUrl + 'Dashboard/'
      }sell-through?companyID=${companyID}&storeID=${storeId}&departmentID=${departmentId}&categoryID=${categoryId}&startDate=${startDateFormatted
      }&endDate=${endDateFormatted}&userID=${user.userId
      }&productionCycleId=${productionCycleId}&subCategoryID=${subCategoryId}`;
    return this.http.get(url);
  }

  getSellThroughChart(
    companyID: number,
    storeId: number,
    userID: number,
    departmentId: string,
    categoryId: number,
    startDate: string | any,
    endDate: string | any,
    productionCycleId: number | null,
    subCategoryId: number = 0
  ) {
    const startDateFormatted = this.formatLocalDateTimeForApi(startDate);
    const endDateFormatted = this.formatLocalDateTimeForApi(endDate);

    const url = `${this.baseUrl + 'Dashboard/'
      }sell-through/rate?companyID=${companyID}&storeId=${storeId}&userID=${userID}&departmentId=${departmentId}&categoryId=${categoryId}&startDate=${startDateFormatted
      }&endDate=${endDateFormatted}&productionCycleId=${productionCycleId}&subCategoryID=${subCategoryId}`;
    return this.http.get(url);
  }

  barcodeLookup(
    barcode: string,
    userId?: number,
    includeDeleted?: boolean
  ): Observable<any> {
    if (!barcode || barcode.trim() === '') {
      return of([]);
    }
    let params = new HttpParams();
    params = params.set('barcode', barcode);
    if (userId) {
      params = params.set('userId', userId);
    }
    if (includeDeleted) {
      params = params.set('includeDeleted', includeDeleted);
    }
    const url = `${this.baseUrl}ProductionHistory`;
    return this.http.get(url, { params });
  }

  scanpullBarcodes(barcodes: string[]) {
    const url = `${this.baseUrl}productionworking/barcodes`;
    return this.http.put(url, barcodes);
  }

  // //for the sort order in week color
  // addUpdateWeekColorSortorder(data: ColorsModel[]) {
  //   const url = `${this.baseUrl + 'colors/'}sortorder`;
  //   return this.http.put(url, data);
  // }

  // getCompanyColorsSchedule() {
  //   let userdata = this.getUserDetailsFromStorage();
  //   let c_id = userdata.companyID;
  //   const url = `${this.baseUrl}colors/${c_id}/companycolorschedule`;
  //   return this.http.get(url);
  // }

  // markActiveColors(clrIds: string) {
  //   const url = `${this.baseUrl + 'colors/'}activate?clrIds=${clrIds}`;
  //   return this.http.post(url, { clrIds });
  // }

  // getPerformerProduction(
  //   companyID: number,
  //   departmentId: number,
  //   startDate: string,
  //   prevStartDate: string,
  //   endDate: string,
  //   prevEndDate: string,
  //   productionCycleID: number,
  //   isItemEntry: boolean
  // ) {
  //   let user = this.getUserDetailsFromStorage();
  //   const url = `${this.baseUrl + 'Performers/'}${
  //     this.performerDashboardURL
  //   }?companyID=${companyID}&departmentId=${departmentId}&startDate=${startDate}&prevStartDate=${prevStartDate}&endDate=${endDate}&prevEndDate=${prevEndDate}&productionCycleID=${productionCycleID}&isItemEntry=${isItemEntry}&userID=${
  //     user.userId
  //   }`;
  //   return this.http.get(url);
  // }
  getEmployeeTopPerformerReport(
    companyId: number,
    userId: number | undefined,
    startDate: string | undefined,
    endDate: string | undefined,
    prevStartDate: string | undefined,
    prevEndDate: string | undefined,
    departmentId: number | undefined,
    productionCycleId: number | undefined,
    prevProductionCycleId: number | undefined,
    isItemEntry: boolean
  ) {
    let params = new HttpParams()
      .set('CompanyId', companyId)
      .set('IsItemEntry', isItemEntry);
    // ?? Only add if not undefined or null
    if (userId !== undefined && userId !== null) {
      params = params.set('UserId', userId);
    }
    if (startDate !== undefined && startDate !== null) {
      params = params.set('StartDate', startDate);
    }
    if (endDate !== undefined && endDate !== null) {
      params = params.set('EndDate', endDate);
    }
    if (prevStartDate !== undefined && prevStartDate !== null) {
      params = params.set('PrevStartDate', prevStartDate);
    }
    if (prevEndDate !== undefined && prevEndDate !== null) {
      params = params.set('PrevEndDate', prevEndDate);
    }
    if (departmentId !== undefined && departmentId !== null) {
      params = params.set('DepartmentId', departmentId);
    }
    if (productionCycleId !== undefined && productionCycleId !== null) {
      params = params.set('ProductionCycleId', productionCycleId);
    }
    if (prevProductionCycleId !== undefined && prevProductionCycleId !== null) {
      params = params.set('PrevProductionCycleId', prevProductionCycleId);
    }
    return this.http.get(`${this.baseUrl}Reports/EmployeeTopPerformer`, {
      params
    });
  }

  getStoreTopPerformerReport(
    companyId: number,
    userId: number | undefined,
    startDate: string | undefined,
    endDate: string | undefined,
    prevStartDate: string | undefined,
    prevEndDate: string | undefined,
    departmentId: number | undefined,
    productionCycleId: number | undefined,
    prevProductionCycleId: number | undefined,
    isItemEntry: boolean
  ) {
    let params = new HttpParams()
      .set('CompanyId', companyId)
      .set('IsItemEntry', isItemEntry);
    // ?? Only add if not undefined or null
    if (userId !== undefined && userId !== null) {
      params = params.set('UserId', userId);
    }
    if (startDate !== undefined && startDate !== null) {
      params = params.set('StartDate', startDate);
    }
    if (endDate !== undefined && endDate !== null) {
      params = params.set('EndDate', endDate);
    }
    if (prevStartDate !== undefined && prevStartDate !== null) {
      params = params.set('PrevStartDate', prevStartDate);
    }
    if (prevEndDate !== undefined && prevEndDate !== null) {
      params = params.set('PrevEndDate', prevEndDate);
    }
    if (departmentId !== undefined && departmentId !== null) {
      params = params.set('DepartmentId', departmentId);
    }
    if (productionCycleId !== undefined && productionCycleId !== null) {
      params = params.set('ProductionCycleId', productionCycleId);
    }
    if (prevProductionCycleId !== undefined && prevProductionCycleId !== null) {
      params = params.set('PrevProductionCycleId', prevProductionCycleId);
    }
    return this.http.get(`${this.baseUrl}Reports/StoreTopPerformer`, {
      params
    });
  }

  resetPriceConfig(
    companyId: number,
    storeGroupId: number,
    departmentIds: string
  ) {
    const url = `${this.baseUrl + 'pricingconfig/'
      }reset/company/${companyId}/group/${storeGroupId}?deptIds=${departmentIds}`;
    return this.http.delete(url);
  }
  // ---------------------------------- Company Management API ----------------------------------
  getUserRoleDetails(userId: number): Observable<UserRolesModel[]> {
    const url = `${this.baseCompanyMangUrl}/Users/${userId}/Roles?Apps=${Apps.TPMPortal}`;
    return this.http.get<UserRolesModel[]>(url);
  }

  getUserDetailsById(userId: number): Observable<UserModel> {
    const url = `${this.baseCompanyMangUrl}/Users/${userId}/Lite`;
    return this.http.get<UserModel>(url);
  }

  getStoreGroupsCompany(companyId: number) {
    const url = `${this.baseCompanyMangUrl}/StoreGroups?CompanyId=${companyId}`;
    return this.http.get(url);
  }

  getWarehouseLocations(comapnyId: number, storeId: number | null) {
    let params = new HttpParams().set('CompanyId', comapnyId.toString());
    if (storeId != null) {
      params = params.set('StoreId', storeId.toString());
    }
    return this.http.get(`${this.baseUrl}SharedWarehouseLocations`, { params });
  }
  //#region New Apis for the licensing
  getAvailableLicenses(companyId: number) {
    let appId = Apps.TPMPortal;
    const url = `${this.baseCompanyMangUrl}/companies/${companyId}/SubscriptionLicenses?AppId=${appId}`;
    return this.http.get(url);
  }

  assignStationLicense(data: any, companyId: number) {
    let appId = Apps.TPMPortal;
    const url = `${this.baseCompanyMangUrl}/Companies/${companyId}/Licenses/Assign`;
    const requestBody = { ...data, appId };
    return this.http.post(url, requestBody);
  }

  unassignStationLicense(data: any, companyId: number) {
    let appId = Apps.TPMPortal;
    const url = `${this.baseCompanyMangUrl}/Companies/${companyId}/Licenses/Unassign`;
    const requestBody = { ...data, appId };
    return this.http.post(url, requestBody);
  }

  createStationSession(data: {
    stationId: number;
    companyId: number;
    licenseId: number;
  }): Observable<CreateStationSessionResponse> {
    return this.http.post<CreateStationSessionResponse>(`${this.baseUrl}Stations/sessions`, data);
  }

  sendLicenseHeartbeat(sessionId: string): Observable<HeartbeatLicenseResponse> {
    return this.http.put<HeartbeatLicenseResponse>(`${this.baseUrl}Stations/license/heartbeat`, { sessionId });
  }
  // //production override and license plate
  // getColorsScheduleByDate(date: any) {
  //   let userdata = this.getUserDetailsFromStorage();

  //   let c_id = userdata.companyID;
  //   const url = `${this.baseUrl + 'colors/'}${
  //     this.getColorsScheduleByDateUrl
  //   }?CompanyID=${c_id}&Date=${date}`;
  //   return this.http.get(url);
  // }

  // Single endpoint used by both the production-override screen (filters by source store)
  // and the inventory/admin override screen (filters by date scope). Both options are
  // optional; the API returns each override with its associated license plates and an
  // isDeletable flag regardless of which filter is supplied.
  getProductionOverrides(
    companyId: number,
    options?: {
      sourceStoreId?: number;
      scope?: 'Current' | 'Expired' | 'All';
    }
  ) {
    const scope = options?.scope ?? 'Current';
    let url = `${this.baseUrl}ProductionOverrides?CompanyId=${companyId}&Scope=${scope}`;
    if (options?.sourceStoreId != null && options.sourceStoreId > 0) {
      url += `&SourceStoreId=${options.sourceStoreId}`;
    }
    return this.http.get(url);
  }

  getProductionOverrideByOverrideId(overrideId: number) {
    const url = `${this.baseUrl}ProductionOverrides/${overrideId}`;
    return this.http.get(url);
  }

  addProductionOverride(overrideObj: ProductionOverride) {
    const url = `${this.baseUrl}ProductionOverrides`;
    return this.http.post(url, overrideObj);
  }

  updateProductionOverride(
    overrideId: number,
    overrideObj: ProductionOverride
  ) {
    const url = `${this.baseUrl}ProductionOverrides/${overrideId}`;
    return this.http.put(url, overrideObj);
  }

  deleteProductionOverride(overrideId: number) {
    const url = `${this.baseUrl}ProductionOverrides/${overrideId}`;
    return this.http.delete(url);
  }

  getAllLicensePlates(
    companyId: number,
    productionOverrideId?: number,
    searchTerm?: string,
    storeId?: number
  ) {
    let params = new HttpParams().set('CompanyId', companyId.toString());
    if (productionOverrideId != null) {
      params = params.set(
        'ProductionOverrideId',
        productionOverrideId.toString()
      );
    }
    if (searchTerm && searchTerm.trim().length > 0) {
      params = params.set('SearchTerm', searchTerm.trim());
    }
    if (storeId != null) {
      params = params.set('StoreId', storeId.toString());
    }
    return this.http.get(`${this.baseUrl}LicensePlates`, { params });
  }

  addLicensePlate(licenseplateObj: LicensePlates) {
    const url = `${this.baseUrl}LicensePlates`;
    return this.http.post(url, licenseplateObj);
  }

  UpdateLicensePlate(licenseplateId: number, licenseplateObj: LicensePlates) {
    const url = `${this.baseUrl}LicensePlates/${licenseplateId}`;
    return this.http.put(url, licenseplateObj);
  }
  UpdateLicensePlateStatus(licenseplateId: number, status: LicensePlateStatus) {
    const url = `${this.baseUrl}LicensePlates/${licenseplateId}/Status`;
    return this.http.put(url, { status });
  }

  associateLicensePlate(
    overrideId: number,
    licenseplate: ProductionOverrideLicensePlates
  ) {
    const url = `${this.baseUrl}ProductionOverrideLicensePlates/${overrideId}/LicensePlates`;
    return this.http.post(url, licenseplate);
  }

  activateProductionOverrideLicensePlate(
    overrideId: number,
    licensePlateId: number
  ) {
    const url = `${this.baseUrl}ProductionOverrideLicensePlates/${overrideId}/LicensePlates/${licensePlateId}/Activate`;
    return this.http.put(url, {});
  }

  addItemToLicensePlate(
    licensePlateId: number,
    itemProduce: LicenseplateItems
  ) {
    const url = `${this.baseUrl}LicensePlateItems/${licensePlateId}/Items`;
    return this.http.post(url, itemProduce);
  }

  getItemOfLicensePlate(licensePlateId: number) {
    const url = `${this.baseUrl}LicensePlateItems/${licensePlateId}/Items`;
    return this.http.get(url);
  }

  updateItemToLicensePlate(
    licensePlateId: number,
    itemId: number,
    itemProduce: LicenseplateItems
  ) {
    const url = `${this.baseUrl}LicensePlateItems/${licensePlateId}/Items/${itemId}`;
    return this.http.put(url, itemProduce);
  }

  addSerialNumberToItem(
    licensePlateId: number,
    itemId: number,
    itemSerial: LicensePlateItemSerial
  ) {
    const url = `${this.baseUrl}LicensePlateItemSerials/${licensePlateId}/Items/${itemId}/Serials`;
    return this.http.post(url, itemSerial);
  }

  getEmptyLicensePlate(CompanyID: number) {
    const url = `${this.baseUrl}LicensePlates/Empty?CompanyId=${CompanyID}`;
    return this.http.get<any>(url);
  }

  createProductionMetadata(metadata: ProductionMetadata) {
    const url = `${this.baseUrl}Productionworking/Metadata`;
    return this.http.post(url, metadata);
  }

  getWarehousesLite(companyId: number, storeId: number) {
    const url = `${this.baseImsUrl}Warehouses/Lite`;
    const params = new HttpParams()
      .set('CompanyId', companyId.toString())
      .set('StoreId', storeId.toString());
    return this.http.get<any[]>(url, { params });
  }

  copyProductionOverride(overrideId: number) {
    const url = `${this.baseUrl}ProductionOverrides/${overrideId}/Copy`;
    return this.http.post(url, {});
  }

  getSellThroughChartV2(
    companyID: number,
    storeId: number,
    userID: number,
    departmentId: string,
    categoryId: number,
    startDate: string | any,
    endDate: string | any,
    productionCycleId: number | null
  ) {
    const startDateFormatted = this.formatLocalDateTimeForApi(startDate);
    const endDateFormatted = this.formatLocalDateTimeForApi(endDate);

    const params = new HttpParams()
      .set('companyId', companyID.toString())
      .set('storeId', storeId.toString())
      .set('userId', userID.toString())
      .set('departmentId', departmentId)
      .set('categoryId', categoryId.toString())
      .set('startDate', startDateFormatted)
      .set('endDate', endDateFormatted)
      .set(
        'productionCycleId',
        productionCycleId ? productionCycleId.toString() : 0
      );

    const url = `${this.baseUrl + 'Reports/'}SellThroughRate`;
    return this.http.get(url, { params });
  }
  getEmployees(companyId: number) {
    const url = `${this.baseUrl}Reports/Employees?companyId=${companyId}`;
    return this.http.get(url);
  }

  // Only the employees with production activity between startDate and endDate — used by the
  // legacy employee report's employee filter so it doesn't list the whole company roster.
  getEmployeesWithReportActivity(
    companyId: number,
    startDate: string | any,
    endDate: string | any
  ) {
    let params = new HttpParams()
      .set('CompanyId', companyId)
      .set('StartDate', startDate ?? '')
      .set('EndDate', endDate ?? '');
    const url = `${this.baseUrl}Reports/EmployeeReport/Employees`;
    return this.http.get(url, { params });
  }
}
